/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const ShapesIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M20 7.07603C20 4.10511 17.5368 1.67437 14.5053 1.67437C11.8737 1.67437 9.66316 3.50263 9.13684 5.9126L5.9579 0.531708L0 10.5663H5.87368V15.5317H15.2632V12.4154C17.9368 12.0414 20 9.79763 20 7.07603ZM5.9579 3.5234L9.2421 9.09127H2.65263L5.9579 3.5234ZM13.7474 14.0566H7.38947V10.5871H11.8947L10.2526 7.82395H13.7474V14.0566ZM15.2632 10.8987V6.32811H10.6105C10.9684 4.54141 12.5684 3.19099 14.5053 3.19099C16.6947 3.19099 18.4632 4.93614 18.4632 7.0968C18.4632 8.96661 17.0947 10.5456 15.2632 10.8987Z"
        fill="white"
      />
    </svg>
  )
}
